import request from '@/axios';

export const getTreeList = projectId => {
  return request({
    url: '/emp-data-center/emp-data/device/treelist',
    method: 'get',
    params: {
      projectId,
    },
  });
};

export const getPage = (current, size, params) => {
  return request({
    url: '/emp-data-center/emp-data/deviceItem/page',
    method: 'get',
    filterEmptyParams: true,
    params: {
      ...params,
      current,
      size,
    }
  })
}


export const getDetail = (id) => {
  return request({
    url: '/emp-data-center/emp-data/deviceItem/detail',
    method: 'get',
    params: {
      id
    }
  })
}

export const update = (row) => {
  return request({
    url: '/emp-data-center/emp-data/deviceItem/update',
    method: 'post',
    data: row
  })
}

export const remove = (ids) => {
  return request({
    url: '/emp-data-center/emp-data/deviceItem/remove',
    method: 'post',
    params: {
      ids,
    }
  })
}

export const alarmSetting = (modelId, params) => {
  return request({
    url: `/emp-data-center/emp-data/model/submitItemAlarm?modelId=${modelId}`,
    method: 'post',
    data: params,
  });
};

export const getAlramList = itemId => {
  return request({
    url: '/emp-data-center/emp-data/deviceItemAlarmSet/list',
    method: 'get',
    params: {
      itemId,
    },
  });
};
